export const regex = {
    name: /^[a-zA-Z]([a-zA-Z0-9-])*$/,
    description: /^[a-zA-Z][a-zA-Z0-9.\- ]*$/,
    uniqueIdentifiers: /^[A-Za-z][A-Za-z0-9]*$/
};

export const exceptionNameMaxLength = 50;
export const exceptionDescMaxLength = 100;
